'use strict';

var cov_21jzk3mtww = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/templatesList/templatesList.js',
        hash = '9f34e232998214e3200b0e45d04de48c730dd4b1',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/templatesList/templatesList.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 63
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 11
                }
            },
            '2': {
                start: {
                    line: 8,
                    column: 12
                },
                end: {
                    line: 8,
                    column: 42
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 42
                    },
                    end: {
                        line: 4,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 4
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 31
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 7,
                        column: 52
                    },
                    end: {
                        line: 7,
                        column: 53
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 66
                    },
                    end: {
                        line: 9,
                        column: 9
                    }
                },
                line: 7
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 9,
                        column: 11
                    },
                    end: {
                        line: 9,
                        column: 12
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 23
                    },
                    end: {
                        line: 11,
                        column: 9
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TemplatesListController = function () {
    function TemplatesListController(NewTemplateModalService) {
        _classCallCheck(this, TemplatesListController);

        cov_21jzk3mtww.f[0]++;
        cov_21jzk3mtww.s[0]++;

        this.NewTemplateModalService = NewTemplateModalService;
    }

    _createClass(TemplatesListController, [{
        key: 'displayNewTemplateModal',
        value: function displayNewTemplateModal() {
            var _this = this;

            cov_21jzk3mtww.f[1]++;
            cov_21jzk3mtww.s[1]++;

            this.NewTemplateModalService.display().then(function (template) {
                cov_21jzk3mtww.f[2]++;
                cov_21jzk3mtww.s[2]++;

                _this.templates.$add(template);
            }, function () {
                cov_21jzk3mtww.f[3]++;
            });
        }
    }]);

    return TemplatesListController;
}();

cov_21jzk3mtww.s[3]++;


angular.module('app').component('templatesList', {
    templateUrl: 'app/components/templatesList/templatesList.html',
    controller: TemplatesListController,
    bindings: {
        templates: '<'
    }
});